import { RefObject } from 'react';
import { useIntersectionObserver } from '@td-client-frontend/common';
import { Group, GroupType } from '../api/api';
import { useDraftQuery } from './useDraftQuery';
import { GroupSearchPayload, useGroupQuery } from './useGroupQuery';

interface Props extends GroupSearchPayload {
  loadMoreRef?: RefObject<HTMLSpanElement>;
}

function useGroupList({ type, search, loadMoreRef }: Partial<Props> & { type: GroupType }) {
  const { values: groupValues, groupStatus } = useGroupQuery({ type, search });
  const { values: draftValues, draftStatus, isFetchingMore, canFetchMore, fetchMore } = useDraftQuery({ type, search });

  useIntersectionObserver({
    // @ts-ignore
    target: loadMoreRef,
    onIntersect: fetchMore,
    enabled: canFetchMore
  });

  const values: Group[] =
    type === GroupType.DRAFT && Array.isArray(draftValues) ? draftValues[0]?.results : groupValues || [];

  return {
    status: type === GroupType.DRAFT ? draftStatus : groupStatus,
    isFetchingMore,
    canFetchMore,
    values
  };
}

export default useGroupList;
